<div class="delete-modal-backdrop">
  <div class="delete-modal">
    <div class="delete-modal-icon-curve">
      <div class="delete-modal-icon">
        <img [src]="iconSrc" alt="Modal Icon" class="delete-icon" loading="lazy" />
      </div>
    </div>
    <h2>{{ title }}</h2>
    <p style="width: 500px;" [innerHTML]="message"></p>
    <div class="delete-modal-actions">
      <button class="btn-cancel" (click)="onCancel()" [disabled]="deleteLoading">{{ cancelText }}</button>
      <button class="btn-submit" *ngIf="bookingCount ==0 " (click)="onConfirm()" [disabled]="deleteLoading">
        <ng-container *ngIf="!deleteLoading">{{ confirmText }}</ng-container>
        <ng-container *ngIf="deleteLoading">
          <span class="spinner"></span>
        </ng-container>
      </button>
    </div>
  </div>
</div> 